import { Box } from '@mui/material'
import { EmrReportImagesViewerContainer } from 'src/mentor/components/PrescriptionMakingPage/printComponents/prescriptionImageRender/uploadedPrescriptionImagesViewerStyledComponents'
import ImageWithMenu from './components/ImageWithMenu'
import { useImageActions } from './hooks/useImageActions'

export default function UploadedEmrReportImagesViewer({
  emrReportData,
  setEmrReportData,
  hiddenInUI = false,
  dontUseSignedUrls = false,
}) {
  const { createImageMenuItems } = useImageActions(emrReportData, setEmrReportData)
  const uploadedSignedImages = dontUseSignedUrls
    ? emrReportData?.uploadedImages
    : emrReportData?.uploadedSignedImages
  
  if (!uploadedSignedImages || !uploadedSignedImages?.length) {
    return null // Don't show anything if no images
  }

  // Images are displayed in the order they appear in the array (page 1 first, then page 2, etc.)
  // The array should already be in the correct sequence from the API
  return (
    <EmrReportImagesViewerContainer hiddenInUI={hiddenInUI}>
      <Box
        className="uploaded-prescription-images"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
          maxWidth: '794px',
          margin: '0 auto',
          '@media print': {
            maxWidth: '100%',
            gap: 0,
          }
        }}
      >
        {uploadedSignedImages.map((imageMediaId, index) => (
          <Box 
            key={`${imageMediaId}-${index}`}
            sx={{
              '@media print': {
                pageBreakAfter: index < uploadedSignedImages.length - 1 ? 'always' : 'auto',
                pageBreakInside: 'avoid',
                width: '100%',
                display: 'block',
              }
            }}
          >
            <ImageWithMenu
              imageMediaId={imageMediaId}
              index={index}
              menuItems={createImageMenuItems(index, imageMediaId)}
              alt="uploaded prescription"
            />
          </Box>
        ))}
      </Box>
    </EmrReportImagesViewerContainer>
  )
}
